class SubscriptionSwitchList {
  prices: SubscriptionSwitchType[];

  constructor(params?: SubscriptionSwitchListSerialized) {
    this.prices = params?.prices || [];
  }
}

export { SubscriptionSwitchList };
